import { render, staticRenderFns } from "./FlexForm.vue?vue&type=template&id=3fb47627&scoped=true&"
import script from "./FlexForm.vue?vue&type=script&lang=js&"
export * from "./FlexForm.vue?vue&type=script&lang=js&"
import style0 from "./FlexForm.vue?vue&type=style&index=0&id=3fb47627&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb47627",
  null
  
)

export default component.exports